import { useKorintConfig } from 'korint-sdk/react';
import { useMemo } from 'react';

const defaultSignatureStatuses: Record<string, string> = {
  PENDING: 'bg-indigo-100 text-indigo-700',
  SIGNED: 'bg-green-100 text-green-700',
  CANCELLED: 'bg-red-100 text-red-700',
  DECLINED: 'bg-red-100 text-red-700',
  ERROR: 'bg-red-100 text-red-700',
};

export function useSignatureStatuses(): Record<string, string> {
  const { signatureStatuses } = useKorintConfig().korintConfig;

  return useMemo(
    () => ({ ...defaultSignatureStatuses, ...signatureStatuses }),
    [signatureStatuses],
  );
}
